var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.608 12.09v-1.726h1.735V8.636h1.734V6.91H12.14V3.455h-1.734V0H8.67v3.455H6.937v3.454H0v1.727h1.734v1.728H3.47v1.727h1.734v1.727H3.469v3.455H1.734V19h3.469v-1.727h1.734v-1.727h1.734v-1.728h1.735v1.728h1.734v1.727h1.734V19h3.469v-1.727h-1.735v-3.455h-1.734v-1.727h1.734Z",
    fill: "currentColor"
  })));
};
export default SvgStar;